var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveCategorizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4981_502262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.3016 27.0984C68.9016 26.6984 68.3016 26.3984 67.7016 26.3984H60.8016L55.5016 21.0984C55.1016 20.6984 54.5016 20.3984 53.9016 20.3984H42.1016C40.9016 20.3984 39.9016 21.3984 39.9016 22.5984V26.3984H28.3016C27.1016 26.3984 26.1016 27.3984 26.1016 28.5984V32.5984L27.9016 34.3984L31.2016 73.2984C31.2016 73.8984 31.5016 74.3984 31.9016 74.7984L52.7016 95.5984C75.1016 93.2984 92.9016 75.6984 95.5016 53.3984L69.3016 27.0984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7969 32.6992L31.2969 73.3992C31.3969 74.5992 32.3969 75.4992 33.4969 75.4992H62.4969C63.6969 75.4992 64.5969 74.5992 64.6969 73.3992L68.1969 32.6992H27.7969Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0984 28.5H39.8984V22.7C39.8984 21.5 40.8984 20.5 42.0984 20.5H53.9984C55.1984 20.5 56.1984 21.5 56.1984 22.7V28.5H56.0984ZM41.5984 26.8H54.2984V22.7C54.2984 22.5 54.0984 22.3 53.8984 22.3H42.0984C41.8984 22.3 41.6984 22.5 41.6984 22.7V26.8H41.5984Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7016 26.5H28.3016C27.1016 26.5 26.1016 27.5 26.1016 28.7V32.7H69.9016V28.7C69.9016 27.5 68.9016 26.5 67.7016 26.5Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1969 32.6992H27.7969L67.6969 37.8992L68.1969 32.6992ZM36.7969 38.1992C36.3969 38.1992 36.0969 38.4992 36.0969 38.8992V70.0992C36.0969 70.4992 36.3969 70.7992 36.7969 70.7992V38.1992Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7969 38.1992V70.8992C37.1969 70.8992 37.4969 70.5992 37.4969 70.1992V38.9992C37.4969 38.5992 37.1969 38.1992 36.7969 38.1992Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4031 38.1992C42.0031 38.1992 41.7031 38.4992 41.7031 38.8992V70.0992C41.7031 70.4992 42.0031 70.7992 42.4031 70.7992V38.1992Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3984 38.1992V70.8992C42.7984 70.8992 43.0984 70.5992 43.0984 70.1992V38.9992C43.0984 38.5992 42.7984 38.1992 42.3984 38.1992Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9969 38.1992C47.5969 38.1992 47.2969 38.4992 47.2969 38.8992V70.0992C47.2969 70.4992 47.5969 70.7992 47.9969 70.7992V38.1992Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 38.1992V70.8992C48.4 70.8992 48.7 70.5992 48.7 70.1992V38.9992C48.7 38.5992 48.4 38.1992 48 38.1992Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5984 38.1992C53.1984 38.1992 52.8984 38.4992 52.8984 38.8992V70.0992C52.8984 70.4992 53.1984 70.7992 53.5984 70.7992V38.1992Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6016 38.1992V70.8992C54.0016 70.8992 54.3016 70.5992 54.3016 70.1992V38.9992C54.3016 38.5992 54.0016 38.1992 53.6016 38.1992Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2 38.1992C58.8 38.1992 58.5 38.4992 58.5 38.8992V70.0992C58.5 70.4992 58.8 70.7992 59.2 70.7992V38.1992Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2031 38.1992V70.8992C59.6031 70.8992 59.9031 70.5992 59.9031 70.1992V38.9992C59.9031 38.5992 59.6031 38.1992 59.2031 38.1992Z",
    fill: "#D5D6DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4981_502262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCategorizer);
export default __webpack_public_path__ + "static/media/remove_categorizer.86552e5e2eb3a5dc91d5a255002d5ba3.svg";
export { ForwardRef as ReactComponent };